import { render, staticRenderFns } from "./Centered.vue?vue&type=template&id=763e9ed0&"
import script from "./Centered.vue?vue&type=script&lang=js&"
export * from "./Centered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports